import { render, staticRenderFns } from "./workspace_actions.vue?vue&type=template&id=24880433&vue3"
import script from "./workspace_actions.vue?vue&type=script&lang=js&vue3"
export * from "./workspace_actions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports